import { typedObjectEntries } from 'infrastructure/functions/typed-object-entries';
import i18n from 'infrastructure/i18n';

export const digitalEngagementTypes = {
  1: i18n.t('digitalEngagement.1'),
  2: i18n.t('digitalEngagement.2'),
} as const;
export type DigitalEngagementType = keyof typeof digitalEngagementTypes;

export interface IDigitalEngagementItem<N extends boolean = false> {
  id: N extends true ? DigitalEngagementType | null : DigitalEngagementType;
  name: string;
}

export function digitalEngagementDataSource(withNull = false) {
  const dataSource = typedObjectEntries(digitalEngagementTypes).map(
    ([id, name]) => ({ id, name }),
  );

  if (withNull) {
    return [
      ...dataSource,
      {
        id: null,
        name: i18n.t('digitalEngagement.none'),
      },
    ];
  }

  return dataSource;
}
